export default class GOTXML2Json
{
	static getXMLDoc(str)
	{
		var element;
		if(window.DOMParser) {
			var getxml = new DOMParser();
			var xmlDoc = getxml.parseFromString(str,"text/xml");
			element = xmlDoc.childNodes[0];
		}
		return element;
	}

	static parseAttributes(xml, jo)
	{
		var atts = xml.attributes;
		for(var k=0; k<atts.length; k++)
		{
			var att = atts[k];
			//alert(att.nodeName + att.textContent);
			jo[att.nodeName] = att.nodeValue || att.textContent;
		}
	}

	static parseProperties(xml, jo)
	{
		var objs = {};
		jo["Properties"] = objs;

		var ps = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();
		for(var k=0; k<ps.length; k++)
		{
			var p = ps[k];
			if(p.nodeName=="Property")
			{
				var obj = {};
				GOTXML2Json.parseAttributes(p, obj);
				var pChildren = p.children || (function(){
					// 兼容IE
					var pChildren = [];
					$.each(p.childNodes,function(i,e){
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							pChildren.push(e);
						}
					});
					return pChildren;
			   })();
				var name = pChildren[0].innerHTML || pChildren[0].textContent.replace(/[\r\n]/g,"").replace(/\ +/g,"");
				var value = pChildren[1].innerHTML || pChildren[1].textContent.replace(/[\r\n]/g,"").replace(/\ +/g,"");
				//alert(name + value);
				obj["Value"] = value;
				objs[name] = obj;
				//alert(JSON.stringify(objs));
			}
		}
		
		return ps;
	}
	static parseFormDataSources(xml)
	{
		var jo = {};
		jo["qname"] = "FormDataSources";
		GOTXML2Json.parseAttributes(xml, jo);
		jo["id"] = "FormDataSources";

		var jarray = [];
		jo["DataSources"] = jarray;

		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();

		for(var i=0; i<childs.length; i++)
		{
			var child = childs[i];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
			else if(nodeName=="FormDataSource")
			{
				jarray.push(GOTXML2Json.parseFormDataSource(child));
			}
		}

		return jo;
	}

	static parseFormDataSourceField(xml)
	{
		var jo = {};
		jo["qname"] = "FormDataSourceField";
		GOTXML2Json.parseAttributes(xml, jo);

		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();
		for(var x=0; x<childs.length; x++)
		{
			var child = childs[x];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
		}
		
		return jo;
	}

	static parseFormDataSourceFieldGroups(xml)
	{
		var jo = {};
		jo["qname"] = "FormDataSourceFieldGroups";
		GOTXML2Json.parseAttributes(xml, jo);

		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();

		for(var x=0; x<childs.length; x++)
		{
			var child = childs[x];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
		}

		return jo;
	}

	static parseFormDataSource(xml)
	{
		var jo = {};
		jo["qname"] = "FormDataSource";
		GOTXML2Json.parseAttributes(xml, jo);
		

		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();
		for(var i=0; i<childs.length; i++)
		{
			var child = childs[i];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
			else if(nodeName=="FormDataSourceFields")
			{
				var jarray = [];
				jo["FormDataSourceFields"] = jarray;
				var ffs = child.children || (function(){
					// 兼容IE
					var children = [];
					$.each(child.childNodes,function(i,e){
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
			   })();
				for(var j=0; j<ffs.length; j++)
				{
					var ff = ffs[j];
					var ffNodeName = ff["nodeName"];
					if(ffNodeName=="Properties")
					{
						GOTXML2Json.parseProperties(ff, jo);
					}
					else
					{
						jarray.push(GOTXML2Json.parseFormDataSourceField(ff));
					}
				}

			}
			else if(nodeName=="FormDataSourceFieldGroups")
			{
				var jarray = [];
				jo["FormDataSourceFieldGroups"] = jarray;
				var ffs = child.children || (function(){
					// 兼容IE
					var children = [];
					$.each(xml.childNodes,function(i,e){
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
			   })();
				for(var j=0; j<ffs.length; j++)
				{
					var ff = ffs[j];
					var ffNodeName = ff["nodeName"];
					if(ffNodeName=="Properties")
					{
						GOTXML2Json.parseProperties(ff, jo);
					}
					else
					{
						jarray.push(GOTXML2Json.parseFormDataSourceFieldGroups(ff));
					}
				}


			}
			else if(nodeName=="FormDataSourceRelation")
			{
				var jarray = [];
				jo["FormDataSourceRelation"] = jarray;
				var ffs = child.children || (function(){
					// 兼容IE
					var children = [];
					$.each(child.childNodes,function(i,e){
						if (Object.prototype.toString.call(e) === "[object Element]") {
							// 判断是元素节点
							children.push(e);
						}
					});
					return children;
			   })();
				for(var j=0; j<ffs.length; j++)
				{
					var ff = ffs[j];
					var ffNodeName = ff["nodeName"];
					if(ffNodeName=="Properties")
					{
						GOTXML2Json.parseProperties(ff, jo);
					}
					else
					{
						jarray.push(GOTXML2Json.parseFormDataSourceField(ff));
					}
				}

			}

		}
			
			
		return jo;

	}

	static parseFormDesign(xml)
	{
		var jo = {};
		jo["qname"] = "FormDesign";
		GOTXML2Json.parseAttributes(xml, jo);
		jo["id"] = "FormDesign";
		jo["parentId"] = 0;
		var jarray = [];
		jo["FormItem"] = jarray;
		
		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();
		for(var i=0; i<childs.length; i++)
		{
			var child = childs[i];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
			else
			{
				jarray.push(GOTXML2Json.parseFormItem(child,"FormDesign"));
			}
		}
		
		return jo;
	}

	static parseFormItem(xml,parentId)
	{
		var jo = {};
		jo["qname"] = "FormItem";
		jo["parentId"] = parentId;
		GOTXML2Json.parseAttributes(xml, jo);

		var jarray = [];
		jo["FormItem"] = jarray;

		var childs = xml.children || (function(){
			// 兼容IE
			var children = [];
			$.each(xml.childNodes,function(i,e){
				if (Object.prototype.toString.call(e) === "[object Element]") {
					// 判断是元素节点
					children.push(e);
				}
			});
			return children;
	   })();
		for(var i=0; i<childs.length; i++)
		{
			var child = childs[i];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
			else
			{
				jarray.push(GOTXML2Json.parseFormItem(child,jo["id"]));
			}
		}
		
		return jo;
	}
		

	static parseForm(xml)
	{
		var jo = {};
		jo["qname"] = "Form";
		GOTXML2Json.parseAttributes(xml, jo);

		var childs = xml.children || (function(){
		     // 兼容IE
		     var children = [];
		     $.each(xml.childNodes,function(i,e){
		         if (Object.prototype.toString.call(e) === "[object Element]") {
		             // 判断是元素节点
		             children.push(e);
		         }
		     });
		     return children;
		})();

		for(var i=0; i<childs.length; i++)
		{
			var child = childs[i];
			var nodeName = child.nodeName;
			if(nodeName=="Properties")
			{
				GOTXML2Json.parseProperties(child, jo);
			}
			else if(nodeName=="FormDataSources")
			{
				jo[nodeName] = GOTXML2Json.parseFormDataSources(child);
			}
			else if(child.nodeName=="FormDesign")
			{
				jo[nodeName] = GOTXML2Json.parseFormDesign(child);
			}
		}

		return jo;
	}
}



// WEBPACK FOOTER //
// ./src/remote/GOTXML2Json.js